export default "/images/vendor/flag-icon-css/flags/4x3/xk.svg?12d1409638442c96c8b9998dfa744c6c";